import { Button } from "@mui/material";
import { Edit } from "@mui/icons-material";
import { useListContext } from "react-admin";

const BulkEditButton = ({ onClick }) => {
    const { selectedIds } = useListContext();
    return (
        (selectedIds.length > 1 && (
            <Button onClick={() => onClick(selectedIds)}>
                <Edit />
                Bulk Edit
            </Button>
        )) ||
        null
    );
};

export default BulkEditButton;
